import { Link } from 'react-router-dom'
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Input,
  Checkbox,
  Button,
  Typography
} from '@material-tailwind/react'

const SignUp = () => {
  return (
    <>
      <img
        src='https://images.unsplash.com/photo-1497294815431-9365093b7331?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1950&q=80'
        className='absolute inset-0 z-0 h-full w-full object-cover'
      />
      <div className='absolute inset-0 z-0 h-full w-full bg-black/50' />
      <div className='container mx-auto p-4'>
        <Card className='absolute top-2/4 left-2/4 w-full max-w-[24rem] -translate-y-2/4 -translate-x-2/4'>
          <CardHeader
            variant='gradient'
            className='mb-4 grid h-28 place-items-center bg-purple-light'
          >
            <Typography variant='h3' color='white'>
              Sign Up
            </Typography>
          </CardHeader>
          <CardBody className='flex flex-col gap-4'>
            <Input label='Name' size='lg' />
            <Input type='email' label='Email' size='lg' />
            <Input type='password' label='Password' size='lg' />
            <div className='-ml-2.5'>
              <Checkbox label='I agree the Terms and Conditions' />
            </div>
          </CardBody>
          <CardFooter className='flex flex-col pt-0 items-center'>
            <div className='items-center w-full'>
              <Link to='/'>
                <Button className='w-full bg-purple-dark text-white text-md'>
                  Sign Up
                </Button>
              </Link>
            </div>
            <div className='block'>
              <Typography variant='small' className='mt-6 flex justify-center'>
                Already have an account?
                <Link to='/'>
                  <Typography
                    as='span'
                    variant='small'
                    className='ml-1 font-bold'
                  >
                    Sign in
                  </Typography>
                </Link>
              </Typography>
            </div>
          </CardFooter>
        </Card>
      </div>
    </>
  )
}

export default SignUp
